import styled from 'styled-components'
import { StyledBox } from '../StyledBox'

export const StyledBoxEmphatic = styled(StyledBox)`
  overflow: hidden;
`
